import { h } from "vue";
import { RouteRecordRaw, RouterView } from "vue-router";

const routes: Array<RouteRecordRaw> = [
    // Additives
    {
        path: "/masterdata/additives",
        component: { render: () => h(RouterView) },
        children: [
            {
                path: "",
                name: "additives",
                meta: { title: "Zusatzstoffe" },
                component: () => import("@/views/masterdata/additives/Additives.vue"),
            },
            {
                path: "create",
                name: "additivescreate",
                meta: { title: "Zusatzstoffe" },
                component: () => import("@/views/masterdata/additives/components/Additive.vue"),
            },
            {
                path: ":id/edit",
                name: "additivesedit",
                meta: { title: "Zusatzstoffe" },
                component: () => import("@/views/masterdata/additives/components/Additive.vue"),
                props: true,
            },
        ],
    },

    // Allergens
    {
        path: "/masterdata/allergens",
        component: { render: () => h(RouterView) },
        children: [
            {
                path: "",
                name: "allergens",
                meta: { title: "Allergene" },
                component: () => import("@/views/masterdata/allergens/Allergens.vue"),
            },
            {
                path: "create",
                name: "allergenscreate",
                meta: { title: "Allergene" },
                component: () => import("@/views/masterdata/allergens/components/Allergen.vue"),
            },
            {
                path: ":id/edit",
                name: "allergensedit",
                meta: { title: "Allergene" },
                component: () => import("@/views/masterdata/allergens/components/Allergen.vue"),
                props: true,
            },
        ],
    },
    // Customercategories
    {
        path: "/masterdata/customer-categories",
        component: { render: () => h(RouterView) },
        children: [
            {
                path: "",
                name: "customercategories",
                meta: { title: "Kundenkategorien" },
                component: () => import("@/views/masterdata/customercategories/CustomerCategories.vue"),
            },
            {
                path: "create",
                name: "customercategoriescreate",
                meta: { title: "Kundenkategorien" },
                component: () => import("@/views/masterdata/customercategories/components/CustomerCategory.vue"),
            },
            {
                path: ":id/edit",
                name: "customercategoriesedit",
                meta: { title: "Kundenkategorien" },
                component: () => import("@/views/masterdata/customercategories/components/CustomerCategory.vue"),
                props: true,
            },
        ],
    },

    // Exportformats
    {
        path: "/masterdata/export-formats",
        component: { render: () => h(RouterView) },
        children: [
            {
                path: "",
                name: "exportformats",
                meta: { title: "Exportformate" },
                component: () => import("@/views/masterdata/exportformats/Exportformats.vue"),
            },
            {
                path: "create",
                name: "exportformatscreate",
                meta: { title: "Exportformate" },
                component: () => import("@/views/masterdata/exportformats/components/ExportFormat.vue"),
            },
            {
                path: ":id/edit",
                name: "exportformatsedit",
                meta: { title: "Exportformate" },
                component: () => import("@/views/masterdata/exportformats/components/ExportFormat.vue"),
                props: true,
            },
        ],
    },

    // Paymentmethods
    {
        path: "/masterdata/paymentmethods",
        component: { render: () => h(RouterView) },
        children: [
            {
                path: "",
                name: "paymentmethods",
                meta: { title: "Zahlungsarten" },
                component: () => import("@/views/masterdata/paymentmethods/Paymentmethods.vue"),
            },
            {
                path: "create",
                name: "paymentmethodscreate",
                meta: { title: "Zahlungsarten" },
                component: () => import("@/views/masterdata/paymentmethods/components/PaymentMethod.vue"),
            },
            {
                path: ":id/edit",
                name: "paymentmethodsedit",
                meta: { title: "Zahlungsarten" },
                component: () => import("@/views/masterdata/paymentmethods/components/PaymentMethod.vue"),
                props: true,
            },
        ],
    },

    // Sales Taxes
    {
        path: "/masterdata/sales-taxes",
        component: { render: () => h(RouterView) },
        children: [
            {
                path: "",
                name: "SalesTaxes",
                meta: { title: "Mehrwertsteuersätze" },
                component: () => import("@/views/masterdata/sales-taxes/SalesTaxes.vue"),
            },
            {
                path: "create",
                name: "SalesTaxesCreate",
                meta: { title: "Mehrwertsteuersätze" },
                component: () => import("@/views/masterdata/sales-taxes/components/SalesTax.vue"),
            },
            {
                path: ":id/edit",
                name: "SalesTaxesEdit",
                meta: { title: "Mehrwertsteuersätze" },
                component: () => import("@/views/masterdata/sales-taxes/components/SalesTax.vue"),
                props: true,
            },
        ],
    },

    // Storages
    {
        path: "/masterdata/storages",
        component: { render: () => h(RouterView) },
        children: [
            {
                path: "",
                name: "Storages",
                meta: { title: "Lagerorte" },
                component: () => import("@/views/masterdata/storages/Storages.vue"),
            },
            {
                path: "create",
                name: "StoragesCreate",
                meta: { title: "Lagerorte" },
                component: () => import("@/views/masterdata/storages/components/Storage.vue"),
            },
            {
                path: ":id/edit",
                name: "StoragesEdit",
                meta: { title: "Lagerorte" },
                component: () => import("@/views/masterdata/storages/components/Storage.vue"),
                props: true,
            },
        ],
    },

    // Units
    {
        path: "/masterdata/units",
        component: { render: () => h(RouterView) },
        children: [
            {
                path: "",
                name: "Units",
                meta: { title: "Mengeneinheiten" },
                component: () => import("@/views/masterdata/units/Units.vue"),
            },
            {
                path: "create",
                name: "UnitCreate",
                meta: { title: "Mengeneinheiten" },
                component: () => import("@/views/masterdata/units/components/Unit.vue"),
            },
            {
                path: ":id/edit",
                name: "UnitEdit",
                meta: { title: "Mengeneinheiten" },
                component: () => import("@/views/masterdata/units/components/Unit.vue"),
                props: true,
            },
        ],
    },

    // Equipment Groups
    {
        path: "/masterdata/equipment-groups",
        component: { render: () => h(RouterView) },
        children: [
            {
                path: "",
                name: "EquipmentGroups",
                meta: { title: "Equipment Warengruppen" },
                component: () => import("@/views/masterdata/equipment-groups/EquipmentGroups.vue"),
            },
            {
                path: "create",
                name: "EquipmentGroupCreate",
                meta: { title: "Equipment Warengruppen" },
                component: () => import("@/views/masterdata/equipment-groups/components/EquipmentGroup.vue"),
            },
            {
                path: ":id/edit",
                name: "EquipmentGroupEdit",
                meta: { title: "Equipment Warengruppen" },
                component: () => import("@/views/masterdata/equipment-groups/components/EquipmentGroup.vue"),
                props: true,
            },
        ],
    },

    // Staff Categories
    {
        path: "/masterdata/staff-categories",
        component: { render: () => h(RouterView) },
        children: [
            {
                path: "",
                name: "StaffCategories",
                meta: { title: "Personal Kategorien" },
                component: () => import("@/views/masterdata/staff-categories/StaffCategories.vue"),
            },
            {
                path: "create",
                name: "StaffCategoriesCreate",
                meta: { title: "Personal Kategorien" },
                component: () => import("@/views/masterdata/staff-categories/components/StaffCategory.vue"),
            },
            {
                path: ":id/edit",
                name: "StaffCategoriesEdit",
                meta: { title: "Personal Kategorien" },
                component: () => import("@/views/masterdata/staff-categories/components/StaffCategory.vue"),
                props: true,
            },
        ],
    },

    // Production Locations
    {
        path: "/masterdata/production-locations",
        component: { render: () => h(RouterView) },
        children: [
            {
                path: "",
                name: "ProductionLocations",
                meta: { title: "Produktionsorte" },
                component: () => import("@/views/masterdata/production-locations/ProductionLocations.vue"),
            },
            {
                path: "create",
                name: "ProductionLocationCreate",
                meta: { title: "Produktionsorte" },
                component: () => import("@/views/masterdata/production-locations/components/ProductionLocation.vue"),
            },
            {
                path: ":id/edit",
                name: "ProductionLocationEdit",
                meta: { title: "Produktionsorte" },
                component: () => import("@/views/masterdata/production-locations/components/ProductionLocation.vue"),
                props: true,
            },
        ],
    },

    // Posting Accounts
    {
        path: "/masterdata/posting-accounts",
        component: { render: () => h(RouterView) },
        children: [
            {
                path: "",
                name: "PostingAccounts",
                meta: { title: "Buchungskonten" },
                component: () => import("@/views/masterdata/posting-accounts/PostingAccounts.vue"),
            },
            {
                path: "create",
                name: "PostingAccountsCreate",
                meta: { title: "Buchungskonten" },
                component: () => import("@/views/masterdata/posting-accounts/components/PostingAccount.vue"),
            },
            {
                path: ":id/edit",
                name: "PostingAccountsEdit",
                meta: { title: "Buchungskonten" },
                component: () => import("@/views/masterdata/posting-accounts/components/PostingAccount.vue"),
                props: true,
            },
        ],
    },

    // Recipe Groups
    {
        path: "/masterdata/recipe-groups",
        component: { render: () => h(RouterView) },
        children: [
            {
                path: "",
                name: "RecipeGroups",
                meta: { title: "Rezept Warengruppen" },
                component: () => import("@/views/masterdata/recipe-groups/RecipeGroups.vue"),
            },
            {
                path: "create",
                name: "RecipeGroupCreate",
                meta: { title: "Rezept Warengruppen" },
                component: () => import("@/views/masterdata/recipe-groups/components/RecipeGroup.vue"),
            },
            {
                path: ":id/edit",
                name: "RecipeGroupEdit",
                meta: { title: "Rezept Warengruppen" },
                component: () => import("@/views/masterdata/recipe-groups/components/RecipeGroup.vue"),
                props: true,
            },
        ],
    },

    // Event Locations
    {
        path: "/masterdata/event-locations",
        component: { render: () => h(RouterView) },
        children: [
            {
                path: "",
                name: "EventLocations",
                meta: { title: "Veranstaltungsorte" },
                component: () => import("@/views/masterdata/event-locations/EventLocations.vue"),
            },
            {
                path: "create",
                name: "EventLocationCreate",
                meta: { title: "Veranstaltungsorte" },
                component: () => import("@/views/masterdata/event-locations/components/EventLocation.vue"),
            },
            {
                path: ":id/edit",
                name: "EventLocationEdit",
                meta: { title: "Veranstaltungsorte" },
                component: () => import("@/views/masterdata/event-locations/components/EventLocation.vue"),
                props: true,
            },
        ],
    },

    // Article Group
    {
        path: "/masterdata/article-groups",
        component: { render: () => h(RouterView) },
        children: [
            {
                path: "",
                name: "ArticleGroups",
                meta: { title: "Artikel Warengruppen" },
                component: () => import("@/views/masterdata/article-groups/ArticleGroups.vue"),
            },
            {
                path: "create",
                name: "ArticleGroupsCreate",
                meta: { title: "Artikel Warengruppen" },
                component: () => import("@/views/masterdata/article-groups/components/ArticleGroup.vue"),
            },
            {
                path: ":id/edit",
                name: "ArticleGroupsEdit",
                meta: { title: "Artikel Warengruppen" },
                component: () => import("@/views/masterdata/article-groups/components/ArticleGroup.vue"),
                props: true,
            },
        ],
    },

    // Suppliercategories
    {
        path: "/masterdata/suppliercategories",
        component: { render: () => h(RouterView) },
        children: [
            {
                path: "",
                name: "suppliercategories",
                meta: { title: "Lieferantenkategorien" },
                component: () => import("@/views/masterdata/suppliercategories/Suppliercategories.vue"),
            },
            {
                path: "create",
                name: "suppliercategoriescreate",
                meta: { title: "Lieferantenkategorien" },
                component: () => import("@/views/masterdata/suppliercategories/components/Create.vue"),
            },
            {
                path: ":id/edit",
                name: "suppliercategoriesedit",
                meta: { title: "Lieferantenkategorien" },
                component: () => import("@/views/masterdata/suppliercategories/components/Create.vue"),
                props: true,
            },
        ],
    },

    // Print Templates
    {
        path: "/masterdata/print-templates",
        component: { render: () => h(RouterView) },
        children: [
            {
                path: "",
                name: "PrintTemplates",
                meta: { title: "Druckvorlagen" },
                component: () => import("@/views/masterdata/print-templates/PrintTemplates.vue"),
            },
            {
                path: "create",
                name: "PrintTemplateCreate",
                meta: { title: "Druckvorlagen" },
                component: () => import("@/views/masterdata/print-templates/components/PrintTemplate.vue"),
            },
            {
                path: ":id/edit",
                name: "PrintTemplateEdit",
                meta: { title: "Druckvorlagen" },
                component: () => import("@/views/masterdata/print-templates/components/PrintTemplate.vue"),
                props: true,
            },
        ],
    },

    // Mail Texts
    {
        path: "/masterdata/mail-texts",
        component: { render: () => h(RouterView) },
        children: [
            {
                path: "",
                name: "MailTexts",
                meta: { title: "Mailtexte" },
                component: () => import("@/views/masterdata/mail-texts/MailTexts.vue"),
            },
            {
                path: "create",
                name: "MailTextCreate",
                meta: { title: "Mailtexte" },
                component: () => import("@/views/masterdata/mail-texts/components/MailText.vue"),
            },
            {
                path: ":id/edit",
                name: "MailTextEdit",
                meta: { title: "Mailtexte" },
                component: () => import("@/views/masterdata/mail-texts/components/MailText.vue"),
                props: true,
            },
        ],
    },

    // Cash Books
    {
        path: "/masterdata/cash-books",
        component: { render: () => h(RouterView) },
        children: [
            {
                path: "",
                name: "CashBooks",
                meta: { title: "Kassenbücher" },
                component: () => import("@/views/masterdata/cash-books/CashBooks.vue"),
            },
            {
                path: "create",
                name: "CashBooksCreate",
                meta: { title: "Kassenbücher" },
                component: () => import("@/views/masterdata/cash-books/components/CashBook.vue"),
            },
            {
                path: ":id/edit",
                name: "CashBooksEdit",
                meta: { title: "Kassenbücher" },
                component: () => import("@/views/masterdata/cash-books/components/CashBook.vue"),
                props: true,
            },
        ],
    },

    // Salutations
    {
        path: "/masterdata/salutations",
        component: { render: () => h(RouterView) },
        children: [
            {
                path: "",
                name: "Salutations",
                meta: { title: "Anreden" },
                component: () => import("@/views/masterdata/salutations/Salutations.vue"),
            },
            {
                path: "create",
                name: "SalutationsCreate",
                meta: { title: "Anreden" },
                component: () => import("@/views/masterdata/salutations/components/Salutation.vue"),
            },
            {
                path: ":id/edit",
                name: "SalutationsEdit",
                meta: { title: "Anreden" },
                component: () => import("@/views/masterdata/salutations/components/Salutation.vue"),
                props: true,
            },
        ],
    },

    // Labelprintformats
    {
        path: "/masterdata/labelprintformats",
        component: { render: () => h(RouterView) },
        children: [
            {
                path: "",
                name: "labelprintformats",
                meta: { title: "Etiketten Druckformate" },
                component: () => import("@/views/masterdata/labelprintformats/Labelprintformats.vue"),
            },
            {
                path: "create",
                name: "labelprintformatcreate",
                meta: { title: "Etiketten Druckformate" },
                component: () => import("@/views/masterdata/labelprintformats/components/Labelprintformat.vue"),
            },
            {
                path: ":id/edit",
                name: "labelprintformatedit",
                meta: { title: "Etiketten Druckformate" },
                component: () => import("@/views/masterdata/labelprintformats/components/Labelprintformat.vue"),
                props: true,
            },
        ],
    },

    {
        path: "/masterdata/textbricks",
        component: { render: () => h(RouterView) },
        children: [
            {
                path: "",
                name: "Textbricks",
                meta: { title: "Textbausteine" },
                component: () => import("@/views/masterdata/textbricks/Textbricks.vue"),
            },
            {
                path: "create",
                name: "textbrickcreate",
                meta: { title: "Textbausteine" },
                component: () => import("@/views/masterdata/textbricks/components/Textbrick.vue"),
            },
            {
                path: ":id/edit",
                name: "textbrickedit",
                meta: { title: "Textbausteine" },
                component: () => import("@/views/masterdata/textbricks/components/Textbrick.vue"),
                props: true,
            },
        ],
    },

    {
        path: "/masterdata/images",
        component: { render: () => h(RouterView) },
        children: [
            {
                path: "",
                name: "Images",
                meta: { title: "Bilder" },
                component: () => import("@/views/masterdata/images/Images.vue"),
            },
            {
                path: "create",
                name: "imagecreate",
                meta: { title: "Bilder" },
                component: () => import("@/views/masterdata/images/components/Image.vue"),
            },
            {
                path: ":id/edit",
                name: "imageedit",
                meta: { title: "Bilder" },
                component: () => import("@/views/masterdata/images/components/Image.vue"),
                props: true,
            },
        ],
    },

];

export default routes;
